import { useEffect } from 'react'

export const usePushNotification = () => {
	useEffect(() => {
		if (Notification.permission !== 'granted') {
			try {
				Notification.requestPermission().then(permission => {
					if (permission !== 'granted') return
				})
			} catch (error) {
				if (error instanceof TypeError) {
					Notification.requestPermission(permission => {
						if (permission !== 'granted') return
					})
				} else {
					console.error(error)
				}
			}
		}

		if ('serviceWorker' in navigator) {
			navigator.serviceWorker
				.register('/push.js')
				.then(registration => {})
				.catch(error => {
					console.error('Service Worker registration failed:', error)
				})
		}
	}, [])

	// 어떤 알림을 보낼 것인지, 몇 초마다 알림을 보낼 것인지에 대한 함수
	const fireNotificationWithTimeout = (title, timeout, options = {}) => {
		if (Notification.permission !== 'granted') return

		const newOption = {
			...options,
			badge: '/favicon.ico',
			icon: '/favicon.ico',
			requireInteraction: true,
			renotify: true, // 알림 중첩 시 미작동 방지
		}
		if (navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage({
				title: title,
				options: newOption,
			})
		}
	}

	return { fireNotificationWithTimeout }
}
